import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { BaseAppGlobalPopUp } from "./BaseAppGlobalPopUp";
import { PMSLocationsActions } from "../../PMS/_actions/PMSLocationsActions";

export function DeleteIntegrationGlobalPopUp({
    integrationUid,
}) {

    //LIBRARIES
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //LOCAL STATE
    // Checked by default → sends delete_invitations=true (backend default).
    // Unchecked keeps guest invitations and accesses (e.g. PMS migration).
    const [deleteInvitations, setDeleteInvitations] = useState(true);

    //ACTION HANDLERS
    function handleDeleteIntegration() {
        dispatch(PMSLocationsActions.deleteLocationIntegration(integrationUid, deleteInvitations));
    }

    //VIEW
    return (
        <BaseAppGlobalPopUp
            title={t("mod_pms_integration_delete_question")}
            body={body()}
            onAccept={handleDeleteIntegration}
        />
    );

    function body() {
        return (
            <div>
                <div>{t("mod_pms_integration_delete_description")}</div>
                <label className="d-flex align-items-center justify-content-center mt-3 mb-0 cp">
                    <input
                        type="checkbox"
                        className="mr-2"
                        checked={deleteInvitations}
                        onChange={e => setDeleteInvitations(e.target.checked)}
                    />
                    <span>{t("mod_pms_integration_delete_invitations_label")}</span>
                </label>
            </div>
        );
    }
}
